import { render, staticRenderFns } from "./UbicacionForm.vue?vue&type=template&id=37dfda86&scoped=true"
import script from "./UbicacionForm.vue?vue&type=script&lang=js"
export * from "./UbicacionForm.vue?vue&type=script&lang=js"
import style0 from "./UbicacionForm.vue?vue&type=style&index=0&id=37dfda86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfda86",
  null
  
)

export default component.exports